"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import deepEqual from 'fast-deep-equal';
import { DataBuilderComponentsProvider } from './components-context.mjs';
import { DataBuilderProvider } from './data-builder-context.mjs';
import { DataBuilderFormField } from './DataBuilderFormField.mjs';
import DataBuilderFormFieldValue from './FieldValue/index.mjs';
import { FormComponentsProvider } from './form-components-context.mjs';
import { formulaComponentMapping } from './Formula/index.mjs';
import DataBuilderFormNested from './Nested.mjs';
import { FormulaComponentsProvider } from './Formula/formula-components-context.mjs';

const EMPTY_ERROR_FIELDS_LOCATORS = [];
const EMPTY_FROZEN_FIELDS_LOCATORS = [];
const EMPTY_EDITABLE_VARIABLES_SCHEMA_LOCATORS = [];
function DataBuilderForm({
  field,
  isAdminMode,
  readOnly,
  onChange,
  errorFieldsLocators = EMPTY_ERROR_FIELDS_LOCATORS,
  frozenFieldsLocators = EMPTY_FROZEN_FIELDS_LOCATORS,
  editableVariablesSchemaLocators = EMPTY_EDITABLE_VARIABLES_SCHEMA_LOCATORS,
  onAddVariable,
  showNullValueFields,
  hideReadOnlyFields,
  collapsed,
  fieldsToShow,
  className
}) {
  function handleOnChange(value) {
    if (!deepEqual(value, field.value)) {
      onChange(value);
    }
  }
  return /* @__PURE__ */ jsx(FormComponentsProvider, { DataBuilderForm, children: /* @__PURE__ */ jsx(FormulaComponentsProvider, { mapping: formulaComponentMapping, children: /* @__PURE__ */ jsx(
    DataBuilderComponentsProvider,
    {
      Nested: DataBuilderFormNested,
      FieldValue: DataBuilderFormFieldValue,
      DataBuilderFormField,
      children: /* @__PURE__ */ jsx(
        DataBuilderProvider,
        {
          topLevelField: field,
          isAdminMode,
          readOnly,
          hideReadOnlyFields,
          errorFieldsLocators,
          frozenFieldsLocators,
          showNullValueFields,
          editableVariablesSchemaLocators,
          onAddVariable,
          collapsedDataBuilder: collapsed,
          initialVisibleFieldCount: fieldsToShow,
          children: /* @__PURE__ */ jsx("div", { className: clsx("max-w-full", className), children: /* @__PURE__ */ jsx(DataBuilderFormField, { field, onChange: handleOnChange }) })
        }
      )
    }
  ) }) });
}

export { DataBuilderForm };
